export const clientRoutesNames = {
    REPORT: 'report',
    SIGNUP: 'signup',
    UPLOADER: '',
    DELETED: 'deleted',
    UNSUPPORTED: 'unsupported',
    SUSPENDED: 'suspended',
    DROPBOX_EXPIRED: 'request-expired',
    TRANSFER_EXPIRED: 'expired',
    PAGE_NOT_FOUND: '404',
    SUBSCRIPTION_UPDATE: 'subscription/update',
    ACCOUNT: 'account',
    REDIRECT: 'redirect',
    REDIRECT_SSO: 'redirect-sso',
    SIGNIN: 'signin',
    SIGNOUT: 'signout',
    SLACK: 'slack',
    PAYPAL: 'paypal',
    PREVIEW: ':id',
    QUOTA_EXCEEDED: 'quota-exceeded',
    INVALID_CONFIGURATION: 'invalid-configuration',
    SERVICE_UNAVAILABLE: 'service-unavailable'
};
